// extracted by mini-css-extract-plugin
export default {"slider-item":"Item_slider-item__68Hav"};